import { useFetchGeneralPage } from "hooks/CMS/GeneralPage/useFetchGeneralPage";
import GeneralPageTemplate from "components/CMSEnabled/GeneralPageTemplate/CMSTemplate";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import APP_URL_CONSTS from "navigation/AppUrls";

const GeneralPage = () => {
  const { loading, error, generalPage } = useFetchGeneralPage();
  const navigate = useNavigate();

  useEffect(() => {
    if (error.isError) {
      if (error.errorType === "pageNotFound") {
        navigate(APP_URL_CONSTS.PAGE_NOT_FOUND, { replace: true });
      }
      if (error.errorType === "apiError" || error.errorType === "other") {
        navigate(APP_URL_CONSTS.ERRORPAGE, { replace: true });
      }
    }
  }, [error, navigate]);

  return (
    <GeneralPageTemplate
      loading={{ isLoading: loading }}
      isError={error.isError}
      generalPage={generalPage}
    />
  );
};

export default GeneralPage;
